import { render, staticRenderFns } from "./AddDict.vue?vue&type=template&id=01fed72c&scoped=true"
import script from "./AddDict.vue?vue&type=script&lang=js"
export * from "./AddDict.vue?vue&type=script&lang=js"
import style0 from "./AddDict.vue?vue&type=style&index=0&id=01fed72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fed72c",
  null
  
)

export default component.exports